module.exports = __webpack_public_path__ + "common/search/icon-men-2127bb483b5155821bb53aa3e9adf26a.svg";